/**
 * google 搜索来源[埋点相关]
 *  wiki: http://wiki.intra.xiaojukeji.com/pages/viewpage.action?pageId=722464750
 */

import qs from '@/utils/urlParam';
import { 
  setSessionStorage, delSessionStorage, getSessionStorage
} from '@/utils/sessionStorage';

class GoogleLogUtil {
  constructor() {
    this.GID = 'gclid';
  }

  getGoogleSource() {
    return window.location?.search.includes('rsc_source')
  }

  getQueryInfo() {
    const rsc_source = qs('rsc_source') || '';
    const rsc_media = qs('rsc_media') || '';
    const rsc_channel = qs('rsc_channel') || '';
    const rsc_campaign = qs('rsc_campaign') || '';
    const rsc_activitiy = qs('rsc_activitiy') || '';
    const rsc_adgroup = qs('rsc_adgroup') || '';
    return {
      rsc_source,
      rsc_media,
      rsc_channel,
      rsc_campaign,
      rsc_activitiy,
      rsc_adgroup,
    }
  }

  getGclid() {
    return getSessionStorage(this.GID) || '';
  }

  setGclid() {
    const gclid = qs(this.GID) || '';
    setSessionStorage(this.GID, gclid);
  }

  delGclid() {
    delSessionStorage(this.GID)
  }
}

const googleLogUtil = new GoogleLogUtil();

export default googleLogUtil;
